import { Directive, HostListener, inject, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { EventEmitter } from 'stream';

@Directive({
  selector: '[onlyTime]',
  standalone: true,
})
export class OnlyTimeDirective {
  private readonly ngControl = inject(NgControl, { optional: true, self: true });

  keyPressed = new BehaviorSubject<string>('');

  @HostListener('keydown', ['$event'])
  onKeyDown(event): void {
    this.keyPressed.next(event.key);
  }

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    let value = event.target.value;

    value = value.replace(/[^0-9:]/g, '');

    const keyPressed = this.keyPressed.value;
    if (value.length === 2 && !value.includes(':') && keyPressed !== 'Backspace') {
      value += ':';
    }

    if (value.length > 5) {
      value = value.slice(0, 5);
    }

    const parts = value.split(':');

    if (parts[0]) {
      let hours = parts[0];
      if (hours.length === 3) {
        const h = hours[0] + hours[1];
        const m = hours.slice(2);
        value = `${h}:${m.padStart(2, '')}`;
      } else if (Number(hours) > 23) {
        hours = '23';
        if (parts[1]) {
          value = `${hours}:${parts[1]}`;
        } else {
          value = `${hours}:`;
        }
      }
    }

    const partsAfter = value.split(':');
    if (partsAfter[1] && Number(partsAfter[1]) > 59) {
      value = `${partsAfter[0]}:59`;
    }

    event.target.value = value;
    // On a ds-input host the inner input writes the raw value to the control first. This keeps the control equal to the shown value.
    if (this.ngControl?.control && this.ngControl.control.value !== value) {
      this.ngControl.control.setValue(value);
    }
  }
}
